import React, { useState, useEffect } from 'react';
import { Chrome, ExternalLink, AlertCircle, FileText } from 'lucide-react';
import { GlossaryExtension } from '../../types/glossary';
import { glossaryService } from '../../services/glossaryService';
import { Button } from '../../components/ui/button';

/**
 * Displays Chrome extension information and download button
 */
export const ChromeExtension: React.FC = () => {
  // Use actual Chrome Web Store data
  const extensionData = {
    version: '1.0.6',
    uploadDate: 'June 18, 2025'
  };

  return (
    <div className="bg-gradient-to-r from-purple-500/80 to-pink-400/80 rounded-lg p-4 shadow-lg relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-300 rounded-full opacity-20 -mr-32 -mt-32"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-pink-300 rounded-full opacity-20 -ml-24 -mb-24"></div>
      
      <div className="flex items-center mb-1">
        <div className="bg-purple-500/50 rounded-full p-1.5 mr-2">
          <Chrome className="h-5 w-5 text-white" />
        </div>
        <h2 className="text-lg font-bold text-white">Chrome Extension</h2>
      </div>
      
      <div className="mb-2 text-sm">
        <div className="flex items-center">
          <span className="text-purple-200 mr-2">Version:</span>
          <span className="text-white font-semibold">{extensionData.version}</span>
        </div>
        <div className="flex items-center">
          <span className="text-purple-200 mr-2">Released:</span>
          <span className="text-white">{extensionData.uploadDate}</span>
        </div>
      </div>
      
      <p className="text-purple-100 mb-3 text-sm">
        The Chrome extension allows you to highlight glossary terms on any webpage and see their definitions.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-2 relative z-10">
        <Button
          className="bg-white hover:bg-purple-50 text-purple-700 font-semibold flex items-center"
          onClick={() => window.open('https://chromewebstore.google.com/detail/jls-glossary-terms/oihnohaciloafjefopppjkmpbkfijbfp', '_blank')}
        >
          <ExternalLink className="h-4 w-4 mr-2" />
          View on Chrome Web Store
        </Button>
        
        <Button
          variant="outline"
          className="bg-purple-700/20 hover:bg-purple-700/30 border-purple-300/50 text-white font-medium flex items-center"
          onClick={() => window.open('https://docs.google.com/document/d/1p0LGCebMc6BHA7aKHO-CQzvz7q_U5uZqeeuRmVDPH1M/edit?tab=t.0', '_blank')}
        >
          <FileText className="h-4 w-4 mr-2" />
          Important Terms Doc
        </Button>
      </div>
    </div>
  );
};